import React, { lazy, memo } from 'react';
const SplitSections = () => {
  return <section className="py-20 bg-white" data-id="element-816">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-817">
        <div className="text-center mb-16" data-id="element-818">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-819">
            Premium Showroom Beverage Solutions
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-820">
            Tailored beverage experiences that elevate customer engagement,
            enhance brand perception, and drive sales conversions
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-821">
          <div data-id="element-822">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-823">
              Elevate the Customer Experience
            </h3>
            <ul className="space-y-4" data-id="element-824">
              <li className="flex" data-id="element-825">
                <div className="flex-shrink-0" data-id="element-826">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-827">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-828">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-829" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-830">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-831">
                    Premium Welcome Experience
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-832">
                    Create a memorable first impression with personalized
                    premium beverages that set the tone for a luxury shopping
                    experience.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-833">
                <div className="flex-shrink-0" data-id="element-834">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-835">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-836">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-837" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-838">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-839">
                    Comfortable Browsing Environment
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-840">
                    Keep customers refreshed and comfortable as they explore
                    your showroom, extending their visit duration and increasing
                    engagement.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-841">
                <div className="flex-shrink-0" data-id="element-842">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-843">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-844">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-845" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-846">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-847">
                    Customizable Refreshment Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-848">
                    Offer a wide variety of premium beverages that can be
                    tailored to your customer demographics and brand
                    positioning.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-849">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-850">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cqpULnnx38kTgbdqducAzH/Car_Dealership_1.webp" alt="SmartSoda beverage system in a luxury Rolls-Royce showroom with premium drinks on display" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-851" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-852">
          <div className="order-2 lg:order-1" data-id="element-853">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-854">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mHLyyQaysCNGfJybnPyYeY/Car_Dealership_2.webp" alt="Sales team members and customers enjoying premium beverages from SmartSoda system in a BMW dealership" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-855" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-856">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-857">
              Enhance Sales Conversations
            </h3>
            <ul className="space-y-4" data-id="element-858">
              <li className="flex" data-id="element-859">
                <div className="flex-shrink-0" data-id="element-860">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-861">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-862">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-863" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-864">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-865">
                    Meaningful Customer Connections
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-866">
                    Create a relaxed atmosphere where sales consultants can
                    build rapport with customers over premium beverages,
                    facilitating more natural conversations.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-867">
                <div className="flex-shrink-0" data-id="element-868">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-869">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-870">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-871" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-872">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-873">
                    Extended Engagement Time
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-874">
                    Keep customers comfortable and engaged in your showroom
                    longer, providing more opportunities to showcase products
                    and close sales.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-875">
                <div className="flex-shrink-0" data-id="element-876">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-877">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-878">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-879" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-880">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-881">
                    Negotiation Environment
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-882">
                    Create a comfortable setting for price discussions and
                    financing conversations, helping customers feel relaxed
                    during decision-making moments.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-883">
          <div data-id="element-884">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-885">
              Strengthen Your Brand Image
            </h3>
            <ul className="space-y-4" data-id="element-886">
              <li className="flex" data-id="element-887">
                <div className="flex-shrink-0" data-id="element-888">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-889">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-890">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-891" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-892">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-893">
                    Elevated Perception
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-894">
                    Enhance your brand's premium positioning with sophisticated
                    beverage offerings that reflect your commitment to
                    excellence in every detail.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-895">
                <div className="flex-shrink-0" data-id="element-896">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-897">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-898">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-899" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-900">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-901">
                    Sustainability Leadership
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-902">
                    Showcase your environmental commitment by eliminating
                    single-use plastics while enhancing the premium nature of
                    your customer experience.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-903">
                <div className="flex-shrink-0" data-id="element-904">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-905">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-906">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-907" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-908">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-909">
                    Memorable Brand Touchpoint
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-910">
                    Create a distinctive element of your customer experience
                    that sets you apart from competitors and becomes part of
                    your brand identity.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-911">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-912">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pogVqXa4cyKz3WQqTE6xV1/Car_Dealership_3.webp" alt="SmartSoda beverage system in a modern BMW showroom with sales consultant and customer" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-913" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-914">
          <div className="order-2 lg:order-1" data-id="element-915">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-916">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s1L1v2p92woHZZKBTKtRrq/Car_Dealership_5.webp" alt="Customers enjoying premium SmartSoda beverages in a luxury Rolls-Royce showroom" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-917" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-918">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-919">
              Seamless Integration Into Your Showroom
            </h3>
            <ul className="space-y-4" data-id="element-920">
              <li className="flex" data-id="element-921">
                <div className="flex-shrink-0" data-id="element-922">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-923">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-924">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-925" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-926">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-927">
                    Elegant Design
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-928">
                    Our sleek, modern dispensing systems blend seamlessly with
                    your showroom aesthetic and can be customized to match your
                    brand environment.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-929">
                <div className="flex-shrink-0" data-id="element-930">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-931">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-932">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-933" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-934">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-935">
                    Versatile Placement Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-936">
                    Position systems in reception areas, consultation spaces, or
                    alongside your premium products to enhance the customer
                    journey at key moments.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-937">
                <div className="flex-shrink-0" data-id="element-938">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-939">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-940">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-941" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-942">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-943">
                    Staff-Friendly Operation
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-944">
                    Intuitive touchscreen interface and minimal maintenance
                    requirements allow your team to focus on what matters
                    most—serving customers and closing sales.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-945">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-946">
            Transform Your Showroom Experience
          </a>
        </div>
      </div>
    </section>;
};
export default SplitSections;